
const camelize = str => str.replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
function getPluginName(ast, name) {
  return `$${name}${camelize(`-${ast}`)}Plugin`;
}
const reportPlugin = {
  install(Vue) {
    Vue.prototype.$report = {
      init: async (params) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')].init) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')].init(params);
        }
      },
      pv: async (params) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')].pv) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')].pv(params);
        }
      },
      expose: async (params) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')].expose) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')].expose(params);
        }
      },
      click: async (params) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')].click) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')].click(params);
        }
      },
      trackClick: async (params) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')].trackClick) {
          await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'report')].trackClick(params);
        }
      },
    };
  },
};

export default reportPlugin;
